import React from 'react';
import { Link } from 'react-router-dom';

export default function SalesOnePager() {
  const handlePrint = () => {
    window.print();
  };

  return (
    <div style={{ background: '#cbd5e1', minHeight: '100vh', paddingBottom: '40px' }}>
      
      {/* Top Floating Control Bar */}
      <div style={{
        position: 'sticky',
        top: 0,
        background: '#0f172a',
        color: '#fff',
        padding: '12px 24px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1000,
        boxShadow: '0 4px 15px rgba(0,0,0,0.2)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <Link to="/" style={{ color: '#38bdf8', textDecoration: 'none', fontWeight: '700', fontSize: '13px' }}>
            ← Back to App
          </Link>
          <span style={{ color: '#475569' }}>|</span>
          <span style={{ fontFamily: 'Outfit, sans-serif', fontWeight: 800, fontSize: '15px' }}>
            PX Reports — Executive B2B Enterprise Sheet (Strict 1-Page A4)
          </span>
        </div>

        <button
          onClick={handlePrint}
          style={{
            background: 'linear-gradient(135deg, #4f46e5 0%, #0284c7 100%)',
            color: '#fff',
            border: 'none',
            padding: '10px 22px',
            borderRadius: '8px',
            fontFamily: 'Outfit, sans-serif',
            fontWeight: 800,
            fontSize: '14px',
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            boxShadow: '0 4px 12px rgba(79, 70, 229, 0.4)',
            transition: 'all 0.2s ease'
          }}
        >
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M6 9V2h12v7"/><path d="M6 18H4a2 2 0 01-2-2v-5a2 2 0 012-2h16a2 2 0 012 2v5a2 2 0 01-2 2h-2"/><rect x="6" y="14" width="12" height="8"/></svg>
          Export to PDF / Print Sheet
        </button>
      </div>

      {/* Embedded Iframe pointing to public px-reports-sales-1pager.html */}
      <div style={{ maxWidth: '960px', margin: '20px auto', background: '#fff', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
        <iframe
          src="/px-reports-sales-1pager.html"
          title="PX Reports Executive B2B Sheet"
          style={{
            width: '100%',
            height: '980px',
            border: 'none',
            display: 'block'
          }}
        />
      </div>

    </div>
  );
}
